import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";

import { useAuth } from "@/contexts/AuthContext";
import { llmStatus } from "@/lib/api";

/**
 * Fix 12: Inviktus has no built-in LLM key. Admins (and consultants) see this strip on every page
 * while there is no usable global credential, or when the primary is failing and the backup serves.
 * Pass `status` to render it from data already loaded (AdminLlmKeys); otherwise it fetches it.
 */
export default function LlmHealthBanner({ status: given = null, compact = false }) {
  const { user } = useAuth();
  const staff = user && ["admin", "consultor"].includes(user.role);
  const [status, setStatus] = useState(given);

  useEffect(() => {
    if (given) { setStatus(given); return; }
    if (!staff) return;
    let alive = true;
    llmStatus().then((s) => alive && setStatus(s)).catch(() => {});
    return () => { alive = false; };
  }, [given, staff]);

  if (!staff || !status) return null;
  const isAdmin = user.role === "admin";
  if (!status.configured) {
    return (
      <div className="border-b border-red-300 bg-red-50 px-6 py-2 text-[13px] text-red-800" data-testid="llm-health-banner-missing">
        <AlertTriangle className="mr-1.5 inline h-4 w-4" />
        <strong>No hay clave LLM configurada.</strong> La entrevista, el informe y los agentes de Inviktus no
        funcionan hasta guardar la clave de OpenRouter{isAdmin ? <> en <Link className="underline" to="/admin/llm">Admin → Claves LLM</Link></> : " (un administrador, en Admin → Claves LLM)"}.
      </div>
    );
  }
  if (status.primary_failing_since && !compact) {
    return (
      <div className="border-b border-amber-300 bg-amber-50 px-6 py-2 text-[13px] text-amber-900" data-testid="llm-health-banner-failing">
        <AlertTriangle className="mr-1.5 inline h-4 w-4" />
        La clave LLM <strong>principal</strong> está fallando desde {new Date(status.primary_failing_since).toLocaleString("es-419")}
        {status.in_use === "backup" ? " · responde la clave de backup" : status.backup_configured ? "" : " · no hay clave de backup"}.
        {isAdmin && <> <Link className="underline" to="/admin/llm">Revisar</Link></>}
      </div>
    );
  }
  return null;
}
